import { ROUTE_SOURCES } from 'src/constants/routeSources';
import type { BlogLocale } from './types';

export function getBlogIndexPath(locale: BlogLocale): string {
  return locale === 'it'
    ? `/${ROUTE_SOURCES.BLOG_IT}`
    : `/${ROUTE_SOURCES.BLOG}`;
}

export function getBlogPostPath(slug: string, locale: BlogLocale): string {
  return locale === 'it'
    ? `/${ROUTE_SOURCES.BLOG_IT}/${slug}`
    : `/${ROUTE_SOURCES.BLOG}/${slug}`;
}
